import { Row, Col } from "../RowCol";
import "../../App.scss";
import  "../../assets/css/libraries.css";
import  "../../assets/css/style.css";
import styled from "styled-components";

const HealthArticleCard = () => {
  return (
    <Card>
      <CardTopBard>
        <h6 style={{ color: "#ffffff" }}>Health Articles & Resources</h6>
        <p style={{  margin: "0px !important"}}>
          Make your health better with out curated blogs, videos and expert
          advice .
        </p>
        <IMG src="/img/medicines-1.svg"></IMG>
      </CardTopBard>
      {/* <div
        style={{ display: "flex", justifyContent: "center", marginTop: "1%" }}
      >
        <p style={{ width: "80%", textAlign: "center", color: "#707070" }}>
          Lorem ipsum dolor sit amet consectetur adipisicing elit. Incidunt,
          cumque tempore esse aut iure quis quam itaque a placeat ab blanditiis
          consectetur similique error pariatur hic sequi, deserunt debitis
          dicta.
        </p>
      </div> */}
      <div >
         {/* <Row>
          <Col area="span 6">
            <h2 style={{ fontWeight: "600" }}>Health Blog</h2>
             <p style={{ color: "#707070" }}>
              Explore health content created everyday by our experts.
            </p> 
          </Col>
         <Col
            area="span 6"
            style={{
              display: "flex",
              justifyContent: "flex-end",
              alignItems: "center",
            }}
          >
            <ArticleButton className="btn  btn-lg">
              Read the latest article
            </ArticleButton>
          </Col> 
        </Row>*/}
        {/* <hr
          style={{
            marginBlock: "2%",
            background: "#CCD0D2",
            border: "1px solid #CCD0D2",
          }}
        />
        <div>
          <p style={{ color: "#707070" }}>You can also</p>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <ExtraActivitesButton>
              Take a mental health scan
            </ExtraActivitesButton>
            <HR />
            <ExtraActivitesButton>Explore Healthy Life</ExtraActivitesButton>
            <HR />
            <ExtraActivitesButton>Join Webinars</ExtraActivitesButton>
          </div>
        </div>*/}
        <div> 
          
 {/* <!-- ======================
      Blog Grid
    =========================  --> */}
    <section className="blog-grid pb-50" style={{paddingTop: "0px", padding: "1rem"}}>
      <div className="container">
        <div className="row">
          <div className="col-sm-12 col-md-12 col-lg-6 offset-lg-3">
            <div className="heading text-center mb-40">
              {/* <h2 className="heading__subtitle">Health Blog</h2> */}
              <h3 className="heading__title">Recent Articles</h3>
            </div>{/* <!-- /.heading  --> */}
          </div>{/* <!-- /.col-lg-6  --> */}
        </div>{/* <!-- /.row  --> */}
        <div className="row">
          {/* <!-- Post Item #1  --> */}
          <div className="col-sm-12 col-md-6 col-lg-4">
            <div className="post-item">
              <div className="post__img" style={{height: "250px"}}>
                <a href="/patient/diabeticblog">
                  <img src="../../assets/images/blog/1.jpeg" alt="post image" loading="lazy"  style={{height:"250px"}}/>
                </a>
              </div>{/* <!-- /.post__img  --> */}
              <div className="post__body">
                <div className="post__meta-cat">
                  <a href="#">Diabetic Diet</a>
                </div>{/* <!-- /.blog-meta-cat  --> */}
                <div className="post__meta d-flex">
                  <span className="post__meta-date">Jan 30, 2022</span>
                  <a className="post__meta-author" href="#">A Das</a>
                </div>
                <h4 className="post__title"><a href="/patient/diabeticblog">Diabetes is a difficult disease to live with</a></h4>

                <p className="post__desc">Alongside the constant medications and blood glucose monitoring, lifestyle modification is the best way to live a long and 
                    otherwise healthy life. As a result, it is essential to modify your diet and get sufficient exercise every day. ...
                </p>
                <a href="/patient/diabeticblog" className="btn btn__secondary btn__link btn__rounded">
                  <span>Read More</span>
                  <i className="icon-arrow-right"></i>
                </a>
              </div>{/* <!-- /.post__body  --> */}
            </div>{/* <!-- /.post-item  --> */}
          </div>{/* <!-- /.col-lg-4  --> */}
          {/* <!-- Post Item #2  --> */}
          <div className="col-sm-12 col-md-6 col-lg-4">
            <div className="post-item">
              <div className="post__img">
                <a href="/patient/healthysleepblog">
                  <img src="../../assets/images/blog/sleep.jpg" alt="post image" loading="lazy"/>
                </a>
              </div>{/* <!-- /.post__img  --> */}
              <div className="post__body">
                <div className="post__meta-cat">
                  <a href="/patient/healthysleepblog">Healthy Sleeping Habits</a>
                </div>{/* <!-- /.blog-meta-cat  --> */}
                <div className="post__meta d-flex">
                  <span className="post__meta-date">Jan 20, 2022</span>
                  <a className="post__meta-author" href="#">A Sengupta</a>
                </div>
                <h4 className="post__title"><a href="/patient/healthysleepblog">Not sleeping well? Feel tired throughout the day?</a></h4>
                <p className="post__desc">As we become increasingly busy with our lives during the day, it becomes equally important to get a good sleep at night. 
                      However, did you know, there are quite some things we all must do to ensure quality sleep..
                </p>
                <a href="/patient/healthysleepblog" className="btn btn__secondary btn__link btn__rounded">
                  <span>Read More</span>
                  <i className="icon-arrow-right"></i>
                </a>
              </div>{/* <!-- /.post__body  --> */}
            </div>{/* <!-- /.post-item  --> */}
          </div>{/* <!-- /.col-lg-4  --> */}
          {/* <!-- Post Item #3  --> */}
          <div className="col-sm-12 col-md-6 col-lg-4">
            <div className="post-item">
              <div className="post__img">
                <a href="blog-single-post.html">
                  <img src="../../assets/images/blog/Eating-healthyWFH.jpg" alt="post image" loading="lazy"/>
                </a>
              </div>{/* <!-- /.post__img  --> */}
              <div className="post__body">
                <div className="post__meta-cat">
                  <a href="#">Life Style</a><a href="#">Nutrition</a>
                </div>{/* <!-- /.blog-meta-cat  --> */}
                <div className="post__meta d-flex">
                  <span className="post__meta-date">Feb 28, 2021</span>
                  <a className="post__meta-author" href="#">Vasudeva Chowhan</a>
                </div>
                <h4 className="post__title"><a href="#">Tips for Eating Healthy When You’re Working From Home </a></h4>

                <p className="post__desc">It’s normal to feel anxiety, worry and grief any time you’re diagnosed with a
                  condition that’s certainly true if you test positive for COVID-19, or are presumed to be positive...
                </p>
                <a href="blog-single-post.html" className="btn btn__secondary btn__link btn__rounded">
                  <span>Read More</span>
                  <i className="icon-arrow-right"></i>
                </a>
              </div>{/* <!-- /.post__body  --> */}
            </div>{/* <!-- /.post-item  --> */}
          </div>{/* <!-- /.col-lg-4  --> */}
        </div>{/* <!-- /.row  --> */}
      </div>{/* <!-- /.container  --> */}
    </section>{/* <!-- /.blog Grid  --> */}
    {/* <!-- ======================
      Blog Grid
    ========================= --> */}
   
     
        </div>
      </div>
      {/* <!-- ========================
       page title 
    =========================== --> */}
  
   
    </Card>
  );
};

const HR = styled.hr`
  flex-grow: 1;
  margin: 0;
  border: 1px solid #707070;
  background: #707070;
  opacity: 1;
`;

const ExtraActivitesButton = styled.button`
  border: 2px solid #01d6c0;
  border-radius: 50px;
  font-weight: 600;
  background-color: #c5f0eb;
  padding: 1% 3%;

  &:hover {
    background-color: #01d6c0;
  }
`;

const ArticleButton = styled.button`
  border-radius: 50px;
  border: 2px solid #01d6c0;
  padding: 3% 5%;
  font-weight: 600;

  &:hover {
    background-color: #01d6c0;
  }
`;

const Card = styled.div`
  margin-top: 4%;
  background-color: white;
  border-top-left-radius: 20px;
  border-top-right-radius: 20px;
  box-shadow: 9px 10px 5px 0px rgba(196, 196, 196, 0.75);
  -webkit-box-shadow: 9px 10px 5px 0px rgba(196, 196, 196, 0.75);
  -moz-box-shadow: 9px 10px 5px 0px rgba(196, 196, 196, 0.75);
`;

const IMG = styled.img`
  position: absolute;
  right: 10%;
`;

const CardTopBard = styled.div`
  & p {
    color: #d4d4d4;
   // margin-bottom: 1%;
   margin: 0px !important;
  }

  & > h1 {
   // margin-top: 1%;
  }

  border-top-left-radius: 20px;
  border-top-right-radius: 20px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: white;
  background-color: #0d233f;
`;

export default HealthArticleCard;
